import { render, staticRenderFns } from "./NoticeAlert.vue?vue&type=template&id=68f5f5d4&scoped=true&"
import script from "./NoticeAlert.vue?vue&type=script&lang=js&"
export * from "./NoticeAlert.vue?vue&type=script&lang=js&"
import style0 from "./NoticeAlert.vue?vue&type=style&index=0&id=68f5f5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5f5d4",
  null
  
)

export default component.exports